import {Injectable} from "@angular/core";
import {ApiService} from "../api.service";
import {HttpClient} from "@angular/common/http";
import {JobFilter} from "../../filters/job.filter";
import {Job} from "../../../shared/types/models/job.model";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class JobService extends ApiService<Job> {
  public filter = new JobFilter();

  constructor(protected httpClient: HttpClient) {
    super(httpClient, 'job');
  }

  public getFilter(): JobFilter {
    return this.filter;
  }

  public calculate$(jobId: string): Observable<any> {
    const url = `${this.url}/${jobId}/calculate`;
    return this.httpClient.get(url);
  }

  public jobNumber(): Observable<any> {
    const url = `${this.url}/jobnumber`;
    return this.httpClient.get(url);
  }

  public quotationNumber(): Observable<any> {
    const url = `${this.url}/quotationnumber`;
    return this.httpClient.get(url);
  }

  public confirmBooking(jobId: string): Observable<any> {
    const url = `${this.url}/${jobId}/confirmbooking`;
    return this.httpClient.post<Job>(url, {}, this.httpOptions);
  }

  public addReportHistory(jobId: string, typeValue: any): Observable<any> {
    const url = `${this.url}/${jobId}/report/${typeValue}`;
    return this.httpClient.post<Job>(url, {}, this.httpOptions);
  }

  public updateService$(jobId: string, serviceId: string): Observable<any> {
    const url = `${this.url}/${jobId}/service/${serviceId}`;
    return this.httpClient.post<Job>(url, {}, this.httpOptions);
  }

  public updateWithNotification$(model: any, notify: boolean): Observable<Job> {
    model.notifyClient = notify;
    return this.httpClient.put<Job>(this.url, model, this.httpOptions);
  }

}
